<div
  fxLayout="row"
  fxLayoutAlign="space-between center"
  class="u-marginBottom-8"
>
  <p
    class="color-grey text-subtitle-2"
    i18n="@@privateSegmentsSelections.title"
  >
    Private segments
  </p>
  <button
    class="c-button color-blue u-textDecoration-underline--hover"
    (click)="openPrivateSegmentsEditDialog(user, account, membership)"
    i18n="@@global.edit"
  >
    Edit
  </button>
</div>
<div
  *ngFor="let segment of segmentsToDisplay"
  fxLayout="row"
  fxLayoutGap="8px"
  class="u-paddingTop-8"
>
  <p
    class="color-grey-300 u-wordWrap-breakWord u-textTruncate"
    [ngStyle]="{ 'max-width': '48%' }"
  >
    {{ segment.title | translationLookup: ['@@groupCustomSegmentTitle'] }}
  </p>
  <p [ngStyle]="{ 'max-width': '60%' }" class="u-wordWrap-breakWord">
    <app-text-list
      *ngIf="segmentsWithSelection[segment._id]?.multiselected_nodes?.length"
      class="u-display-block color-grey"
      [list]="
        segmentsWithSelection[segment._id]?.multiselected_nodes
          | translationLookupList: ['@@groupCustomSegmentOption']
      "
    >
    </app-text-list>
  </p>
  <p
    *ngIf="segmentsWithSelection[segment._id]?.node"
    [ngStyle]="{ maxWidth: '50%' }"
    class="u-textTruncate"
  >
    {{
      segmentsWithSelection[segment._id]?.node
        | translationLookup: ['@@groupCustomSegmentOption']
    }}
  </p>
  <i
    *ngIf="
      !segmentsWithSelection[segment._id]?.node &&
      !segmentsWithSelection[segment._id]?.multiselected_nodes?.length
    "
    class="color-grey-300"
    i18n="@@global.notSpecifiedLabel"
  >
    Not specified
  </i>
</div>
